import React from 'react';
import { Modal, View, SafeAreaView } from 'react-native';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import VFLottieView, { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView';
import PropTypes from 'prop-types';

import ButtonsSection from '../../../CreateInstalmentMainScreen/components/ButtonsSection/ButtonsSection';

import style from './style';

class InstalmentSuccessModal extends React.Component {
  getButtonSectionProps = () => {
    const { theme, onPressPrimary } = this.props;
    return {
      primaryButtonTitle: 'billing_success_installment_primary_button_title',
      secondaryButtonTitle: 'billing_success_installment_secondary_button_title',
      theme: theme,
      containerStyle: style.buttonsSectionContainer,
      onPressPrimary,
    };
  };
  HeaderSection = () => {
    const { theme } = this.props;
    return (
      <VFText
        i18nKey="billing_setup_installment_plan_screen_title"
        style={style.headerStyle(theme)}
      />
    );
  };
  BodySection = () => {
    const { theme, dayOfMonthlyBill, nextMonth } = this.props;
    return (
      <View style={style.bodySectionContainer}>
        <VFLottieView
          autoPlay
          containerStyle={style.modalIconContainer}
          loop={false}
          lottieViewStyle={style.iconContainer}
          type={LottieTypes.tick}
        />

        <VFText i18nKey="billing_success_installment_plan_message" style={style.message(theme)} />
        <VFText
          i18nKey="billing_success_installment_plan_description"
          placeHolders={[nextMonth, dayOfMonthlyBill + ' ' + nextMonth]}
          style={style.description(theme)}
        />
      </View>
    );
  };
  render() {
    const { theme } = this.props;
    return (
      <Modal visible={true}>
        <SafeAreaView style={style.containerStyle(theme)}>
          {this.HeaderSection()}
          {this.BodySection()}
          <ButtonsSection {...this.getButtonSectionProps()} />
        </SafeAreaView>
      </Modal>
    );
  }
}
InstalmentSuccessModal.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }).isRequired,
  onPressPrimary: PropTypes.func.isRequired,
  dayOfMonthlyBill: PropTypes.string.isRequired,
  nextMonth: PropTypes.string.isRequired,
};
export { InstalmentSuccessModal };
export default withTheme(InstalmentSuccessModal);
